





module.exports =
  name: 'transaction_amount'
  props: ['transaction']
